import { createApp } from 'vue';
import App from './App.vue';
const app = createApp(App);

// import 'vue-toast-notification/dist/theme-sugar.css';

//Add extension
import './commons/prototype';

// Globally Registered Components
import { useComponents } from '@/commons/globalComponents.js';
useComponents(app);

//phím tắt
import { shortKey } from '@/commons/directives/shortkey.js';
app.directive('shortkey', shortKey);

// Globally Registered Components
import { pluginInstall } from '@/commons/globalPlugin.js';
pluginInstall(app);

//Đăng ký popup
import { register } from '@/commons/globalPopup.js';
register(app);

// filter
import { initFilter } from './commons/msFormat';
initFilter(app);

// Styles: SCSS
import '@/assets/css/flexbox.css';
import '@/assets/css/common.css';
import '@/assets/scss/scroller.scss';
import '@/assets/scss/override.scss';
import '@/assets/scss/icons.scss';
import '@/assets/scss/btn.scss';
import '@/assets/scss/form.scss';
import '@/assets/scss/app.scss';
import '@/assets/scss/main-style.scss';
import 'v3-tour/dist/vue-tour.css';

app.config.productionTip = false;

// Vue.config.errorHandler = log.handleGlobalException;
if (process.env.NODE_ENV == 'development') {
  app.config.performance = true;
}

/**
 * directive xử lý style.visibility
 */
app.directive('visible', function (el, binding) {
  el.style.visibility = binding.value ? 'visible' : 'hidden';
});

//Khai báo router
import router from '@/routers/router';
app.use(router);

//Khai báo store
import store from '@/stores/store';
app.use(store);

//Sử dụng localize
import i18n from '@/i18ns/i18n';
app.use(i18n);

import { PromiseDialog } from 'vue3-promise-dialog';
app.use(PromiseDialog);

/** Vue tour step */
import vueTour from 'v3-tour';
app.use(vueTour);

import VueApexCharts from 'vue3-apexcharts';
app.use(VueApexCharts);

app.mount('#app');

import { useSyncTabData } from '@/setup/utilities/syncTabData.js';
import { showError } from '@/commons/globalMessage';

const keySync = window.syncKeyToken;
useSyncTabData(keySync, (id) => {
  showError('Phần mềm sẽ tự động tải lại trang để đảm bảo toàn vẹn dữ liệu.', 'Đã thay đổi thông tin dữ liệu').then(() => {
    location.reload();
  });
})


import { useContextStorage } from '@/composables/contextStorage/useContextStorage';
const { setCookieContext } = useContextStorage();


const onTabActive = () => {
  setCookieContext();
}

import { useRefreshToken} from '@/composables/refreshToken/useRefreshToken';
const { subscribeSyncRefreshToken } = useRefreshToken();

/**
 * Subcrible thay đổi giữa các tab khi thực hiện refresh token
 * NHANH3 20.02.2025
 */
subscribeSyncRefreshToken();

document.addEventListener("visibilitychange", () => {
  if (document.hidden) {
    //Compatible with old version
    // onTabInactive();
  } else {
    onTabActive();
  }
})

window.addEventListener('focus',()=>{
  onTabActive();
})
